export interface InvitationSecret {
  invitationId: string;
  token: string;
}

export function consumeInvitationSecret(): InvitationSecret | null {
  const value = new URLSearchParams(window.location.hash.slice(1)).get(
    "invite",
  );
  window.history.replaceState(
    window.history.state,
    "",
    window.location.pathname,
  );
  if (!value) return null;
  const separator = value.indexOf(".");
  if (separator < 1) return null;
  const invitationId = value.slice(0, separator);
  const token = value.slice(separator + 1);
  if (
    !/^inv_[A-Za-z0-9_-]{8,80}$/.test(invitationId) ||
    !/^[A-Za-z0-9_-]{43}$/.test(token)
  ) {
    return null;
  }
  return { invitationId, token };
}
